import axios from 'axios';

const baseReq = axios.create({
    baseURL: '',
    timeout: 5000
  });

export function  getpromoCodeUse(){
    return baseReq.get('/kzbusiness/api/v1/public/promotion/income').then(res => res.data.data );
}